const Showcase = ({ variant = 'default' }) => {
  const contentByVariant = {
    quiz: '',
    homestead: 'Urban homesteading in the heart of Las Vegas',
    default: 'Urban homesteading in the heart of Las Vegas',
  };

  return (
    <section id="showcase" className={`non-printable ${variant === 'quiz' && 'quiz-showcase'}`}>
      <div className="container">
        {variant !== 'quiz' && <h1>{variant ? contentByVariant[variant] : contentByVariant.default}</h1>}
      </div>
    </section>
  )
}

export default Showcase
